import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { TrackingProperties } from '../scorecard';
import { formatDistance } from 'date-fns';
import { NgSwitch, NgSwitchCase, DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

type SnapshotStatus = 'active' | 'expired' | 'outdated' | 'unknown';

@Component({
  selector: 'snap-action-refresh',
  templateUrl: './action-refresh.component.html',
  styleUrls: ['./action-refresh.component.scss'],
  imports: [NgSwitch, NgSwitchCase, MatButton, ProductAnalyticsModule, MatIcon, DatePipe, TranslateModule],
})
export class ActionRefreshComponent implements OnInit {
  @Input() created: Date;
  @Input() expired: Date;
  @Input() snapshotName: string;
  @Input() trackingProperties: TrackingProperties;

  @Output() refreshSnapshotClicked: EventEmitter<void> = new EventEmitter<void>();

  snapshotStatus: SnapshotStatus;
  snapshotCreatedDaysAgo: string;

  ngOnInit(): void {
    this.snapshotStatus = this.getSnapshotStatus(this.expired);
    this.snapshotCreatedDaysAgo = formatDistance(this.created, new Date(), { addSuffix: true });
  }

  refreshSnapshot(): void {
    this.refreshSnapshotClicked.emit();
  }

  getSnapshotStatus(expiry: Date): SnapshotStatus {
    if (expiry === undefined) {
      return 'unknown';
    }
    const now = new Date();
    const expiryPlus3Months = new Date(expiry).setMonth(expiry.getMonth() + 3);

    if (now < expiry) {
      return 'active';
    }
    if (now < new Date(expiryPlus3Months)) {
      return 'expired';
    }
    return 'outdated';
  }
}
